import { ITelemetryItem } from '@microsoft/applicationinsights-web';

export function filterTelemetry(item: ITelemetryItem): boolean | void {
  if (item.baseType === 'ExceptionData') {
    const message = Array.isArray(item.baseData?.['exceptions'])
      ? item.baseData?.['exceptions'][0]?.message
      : (item.baseData?.['message'] as string | null);

    if (message?.includes("ReferenceError: Can't find variable: msDiscoverChatAvailable") && item.baseData) {
      return false;
    }
  }
  return true;
}
